module.exports = __webpack_public_path__ + "static/media/CTLA_4-286w.29988e71.webp";